import React from 'react';
import { Box, Stack } from '@mui/material';
import { BpfLinkType } from '@trnsact/trnsact-shared-types';

import { AttributeRenderers } from './types';
import { Checklist } from './attributesComponents';
import { Stage, UpdateStageFields } from '../../api';

interface Props {
  stage: Stage;
  parentId: string;
  isLoading: boolean;
  parentType: BpfLinkType;
  onUpdateStageAttributes: (dto: UpdateStageFields) => Promise<void>;
}

export const StageAttributes = ({ parentId, parentType, stage, isLoading, onUpdateStageAttributes }: Props) => {
  const stageFields = stage.fieldValues?.values?.length ? stage.fieldValues.values : stage.stageFields;

  const attributeRenderers: AttributeRenderers = {
    checklist: attribute => (
      <Checklist
        checklist={attribute}
        isLoading={isLoading}
        onChange={async (checklistItem, nextValue) => {
          await onUpdateStageAttributes({
            parentId,
            parentType,
            stageId: stage.businessProcessFlowStageId,
            stageFields: stageFields.map(field => {
              if (field.field === 'checklist') {
                return {
                  ...field,
                  value: field.value.map(fieldValue => {
                    if (fieldValue.name === checklistItem.name) {
                      return { ...fieldValue, value: nextValue };
                    }

                    return fieldValue;
                  }),
                };
              }

              return field;
            }),
          });
        }}
      />
    ),
  };

  return (
    <Stack gap="1rem">
      {stageFields.map((attribute, index) => (
        <Box className="attribute" key={`${attribute.field}_${index}`}>
          {attributeRenderers[attribute.field] && attributeRenderers[attribute.field](attribute as any)}
        </Box>
      ))}
    </Stack>
  );
};
